import React, { useState } from "react";
import Select from "react-dropdown-select";
import { useQuery } from "react-apollo";
import { GET_DESIGNATION } from "../queries/designation.query";
import { toast } from "react-toastify";
import { CleanMessage } from "../util/app";
import LoadingSpinner from "./loading";
import auth from "../providers/Auth.Provider";

const DesignationDownList = ({ onChange }) => {
    const [options, setOptions] = useState([]);
    const { site } = auth.authProvider.GetAuthenticatedStaff();

    const { loading } = useQuery(GET_DESIGNATION, {
        onError: e => toast.error(CleanMessage(e.message)),
        onCompleted: d => {
            if (d.GetAllDesignation) {
                const { docs } = d.GetAllDesignation;
                setOptions(docs);
            }
        },
        variables: { site: site.id }
    });

    return (
        <>
            <LoadingSpinner loading={loading} bar={true} />
            <Select
                options={options}
                multi={false}
                valueField="id"
                labelField="name"
                onChange={values => onChange(values[0])}
                searchable={true}
                color="#0066f5 "
                searchBy="name"
                clearable={true}
                separator={true}
                placeholder="Select Designation"
            />
        </>
    );
};

export default DesignationDownList;
